// extracted by mini-css-extract-plugin
export var hideEditor = "_lo-2";
export var infoIcon = "_lo-3";
export var label = "_lo-1";
export var labelContainer = "_lo-0";
export var readonlyText = "_lo-4";